import React from 'react';
import ScrollTrigger from 'react-scroll-trigger';
import Plx from 'react-plx';
import { DragSource, DropTarget } from 'react-dnd';
import { elementSource, elementTarget } from './elementDragUtils';
import AbstractCmsElement from 'components/cms/elements/AbstractCmsElement';

@DropTarget('element', elementTarget, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('element', elementSource, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class CmsElementNavigation extends AbstractCmsElement {

  constructor(props) {
    super(props);

    this.allowStateChange = true;

    this.state = {
      shown: false,
    };
  }

  shown = () => {
    if (this.allowStateChange) {
      this.setState({ shown: true });
    }
  }

  showSettings = e => {
    this.props.showElementSettings(e, this.props.index);
  }

  getHoverStyle = () => {
    const hoverColor = this.getParamValue('textHoverColor', '');
    const hoverBackgroundColor = this.getParamValue('backgroundHoverColor', '');

    if (!hoverColor && !hoverBackgroundColor) {
      return null;
    }

    let css = '#' + this.getMainId() + ' .ms-navigation-child-link:hover { ';
    if (hoverColor) {
      css += 'color: ' + hoverColor + ' !important; ';
    }
    if (hoverBackgroundColor) {
      css += 'background-color: ' + hoverBackgroundColor + ' !important; ';
    }
    css += '}';

    return <style type="text/css" dangerouslySetInnerHTML={{ __html: css }} />;
  };

  render() {
    const { connectDropTarget, connectDragSource, connectDragPreview } = this.props;
    const { shown } = this.state;

    const shownClass = shown ? 'elem-shown ' : 'elem-hidden ';
    const fontSize = this.getParamValue('fontSize', '');
    const textColor = this.getParamValue('textColor', '');

    const parallaxData = this.getParallaxData();

    const innerContent = (
      <ul
        id={this.getMainId()}
        className={'ms-navigation list-unstyled relative ' + shownClass + this.getCssClasses()}
        onClick={this.showSettings}
        style={{
          ...this.getBackgroundStyle(),
          fontSize: fontSize ? fontSize + 'px' : undefined,
          color: textColor || undefined,
        }}
      >
        {this.getElementStyle()}
        {this.getHoverStyle()}

        {this.props.children && this.props.children.length ? (
          this.props.children
        ) : (
          <li className="p-t-15 p-b-15 text-center">
            <i className="fa fa-bars fa-4x" />
          </li>
        )}
      </ul>
    );

    return connectDropTarget(
      connectDragSource(
        connectDragPreview(
          <div>
            <ScrollTrigger onEnter={this.shown} {...this.getCustomId()}>
              {parallaxData ? <Plx parallaxData={parallaxData}>{innerContent}</Plx> : innerContent}
            </ScrollTrigger>
          </div>
        )
      )
    );
  }
}